<template>
  <div class="popUpWrap">
    <section class="popup dark subscription">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close" />
      </div>
      <div class="scrollY">
        <div class="icon rec" />
        <div class="textArea flex">
          <h5>{{ t('organization-subscription-change-billing-cycle-title') }}</h5>
          <p v-html="convertToNextLine(t('organization-subscription-change-billing-cycle-description-2'))" />
        </div>
        <div class="changePlan flex gap-4">
          <div class="boxArea">
            <div class="titleArea">
              <p>{{ t('organization-subscription-current-billing-cycle') }}</p>
              <h5>{{ dialogStore.options.props.currentCycleName }}</h5>
            </div>
          </div>
          <div class="boxArea">
            <div class="titleArea">
              <p>{{ t('organization-subscription-change-billing-cycle-description-1') }}</p>
              <h5>{{ dialogStore.options.props.newCycleName }}</h5>
            </div>
          </div>
        </div>
        <div class="btnArea">
          <button type="button" class="cancel" @click.stop="dialogStore.close">{{ t('common-cancel') }}</button>
          <button type="button" @click.stop="onClickChangeBillingCycle">
            {{ t('organization-subscription-change-billing-cycle-button') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {useDialogStore} from '~/store/dialog/dialogStore';

const {t} = useI18n();
const dialogStore = useDialogStore();

const onClickChangeBillingCycle = () => {
  dialogStore.close();
  dialogStore.options.confirm?.event()
}
</script>
